<i
  class="fa sortable"
  [ngClass]="{ 'fa-caret-down': 'DESC' === order, 'fa-caret-up': 'ASC' === order }"
  (click)="onSort()"
  aria-hidden="true"
></i>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/sortable/sortable.component.html